import { mapEnumToOptions } from '@abp/ng.core';

export enum FormStatus {
  New = 0,
  Committed = 1,
  Active = 2,
  OnHold = 3,
  Cancelled = 4,
  Done = 5,
}

export const formStatusOptions = mapEnumToOptions(FormStatus);
